import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { environment } from '../../../environments/environment';

import * as _ from 'lodash';
import { tap } from 'rxjs/operators';

@Injectable()
export class MenuService {
    public baseUrl = environment.baseUrl;
    private _menus: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private _menuSubs: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private _currentMenus: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(
        private _http: HttpClient,
        ) {}
    public getMenus(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.MENU.GET_MENUS}`).pipe(tap(data => {
            if(!data) {
                return;
            }
            this._menus.next(data);
            let menuSub = data;
            const groupByParent = _.groupBy(data, (o) => {
                return o.parentID;
            });
            let result = [];
            _.keys(groupByParent).map((key) => {
                const temp = groupByParent[key].map(x => {
                    x.children = groupByParent[x.id];
                    return x;
                }).filter(x => x.children);
                if(temp && temp.length) {
                    result = [...result, ...temp];
                }
                menuSub = result;
            });
            menuSub.map((m) => {
                m.routerLink = m.name.toLowerCase().replace(/\s/g, '-');
                m.children.map((mc) => {
                    mc.routerLink = m.routerLink + '/' + mc.name.toLowerCase().replace(/\s/g, '-');
                })
                return m;
            });
            this._menuSubs.next(menuSub);

            return menuSub;
        }));
    }
    public get menus() {
        return this._menus.asObservable();
    }
    public get menuSubs() {
        return this._menuSubs.asObservable();
    }
    public get currentMenus() {
        return this._currentMenus.asObservable();
    }

    public activeMenu(menu: any) {
        if(menu) {
            this._currentMenus.next([...menu.children]);
        }
    }

    public getMenusForCurrentUser(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.MENU.CURRENT_LOGIN}`).pipe(tap(data => {
            if(!data) {
                return;
            }
            this._menus.next(data);
            let menuSub = data;
            const groupByParent = _.groupBy(data, (o) => {
                return o.parentID;
            });
            let result = [];
            _.keys(groupByParent).map((key) => {
                const temp = groupByParent[key].map(x => {
                    x.children = groupByParent[x.id];
                    return x;
                }).filter(x => x.children);
                if(temp && temp.length) {
                    result = [...result, ...temp];
                }
                menuSub = result;
            });
            menuSub.map((m) => {
                m.routerLink = m.name.toLowerCase().replace(/\s/g, '-');
                m.children.map((mc) => {
                    mc.routerLink = m.routerLink + '/' + mc.name.toLowerCase().replace(/\s/g, '-');
                })
                return m;
            });
            this._menuSubs.next(menuSub);

            return menuSub;
        }));
    }
}